<template>
  <b-modal
    id="errorManagerModal"
    size="xl"
    content-class="menu-bg-blue-transparent-modal"
    title="Delivery Review Tool Error Manager"
    scrollable
    hide-footer
   
  >
    <vue-bootstrap4-table
      :columns="columns"
      :config="config"
      :classes="classes"
      :rows="rows"
    >
      <template slot="id" slot-scope="props">
        <div @dblclick="zoomToError(props.row.x, props.row.y)">
          {{ props.cell_value }}
        </div>
      </template>
      <template slot="comments" slot-scope="props">
        <div @dblclick="zoomToError(props.row.x, props.row.y)">
          {{ props.cell_value }}
        </div>
      </template>
      <template slot="layer" slot-scope="props">
        <div @dblclick="zoomToError(props.row.x, props.row.y)">
          {{ props.cell_value }}
        </div>
      </template>
      <template slot="dataset" slot-scope="props">
        <div @dblclick="zoomToError(props.row.x, props.row.y)">
          {{ props.cell_value }}
        </div>
      </template>
      <template slot="status" slot-scope="props">
        <div @dblclick="zoomToError(props.row.x, props.row.y)">
          {{ props.cell_value }}
        </div>
      </template>
      <template slot="severity" slot-scope="props">
        <div @dblclick="zoomToError(props.row.x, props.row.y)">
          {{ props.cell_value }}
        </div>
      </template>
    </vue-bootstrap4-table>
  </b-modal>
</template>

<style scoped></style>

<script>
import VueBootstrap4Table from 'vue-bootstrap4-table'
import axios from 'axios'
import {transform} from 'ol/proj'
export default {
  name: 'MMP_DRT_ErrorManager',
  components: {
    VueBootstrap4Table
  },
  props: ['customerProjectId', 'map'],
  data() {
    return {
      columns: [
        {
          column_text_alignment: 'text-left',
          label: 'ID',
          name: 'id',
          row_text_alignment: 'text-left',
          uniqueId: true
        },
        {
          column_text_alignment: 'text-left',
          label: 'Comments',
          name: 'comments',
          row_text_alignment: 'text-left'
        },
        {
          column_text_alignment: 'text-left',
          label: 'Layer',
          name: 'layer',
          row_text_alignment: 'text-left'
        },
        {
          column_text_alignment: 'text-left',
          label: 'Dataset',
          name: 'dataset',
          row_text_alignment: 'text-left'
        },
        {
          column_text_alignment: 'text-left',
          label: 'Status',
          name: 'status',
          row_text_alignment: 'text-left'
        },
        {
          column_text_alignment: 'text-left',
          label: 'Severity',
          name: 'severity',
          row_text_alignment: 'text-left'
        }
      ],
      config: {
        card_mode: false,
        global_search: {
          placeholder: 'Search...',
          // Wait 250ms post-keyup to begin search.
          // 60ms is default, but too low of a value can cause lag.
          searchDebounceRate: 250,
          visibility: true
        },
        highlight_row_hover_color: '#4a4a4a',
        pagination: true,
        show_refresh_button: false,
        show_reset_button: false
      },
      classes: {
        table: {
          'menu-bg-blue-transparent-modal': true
        }
      },
      errors: null,
      feedback: null,
      partnumber: null,
      layers: null,
      layersObj: null,
      org_name: null,
      projectId: this.customerProjectId ? this.customerProjectId : 0,
      release: null,
      releases: null,
      rows: [],
      user: null,
      zoomControlArr: null
    }
  },
  methods: {
    zoomToError(x, y) {
      // REFACTORED - changed || to &&
      //    before: x != null || y != null
      if (x != null && y != null) {
        var coord = new transform([x, y], 'EPSG:4326', 'EPSG:3857')
        this.map.getView().setCenter(coord)
        this.map.getView().setZoom(19.5)
      }
    },
    getErrorsByProjectId() {
      // REFACTOR - added sessionStorage.token check
      if (sessionStorage.token) {
        axios
        .get(process.env.API_LOCATION + '/api/error/' + this.projectId, {
          headers: {
            'x-auth-token': sessionStorage.token
          }
        })
        .then(response => {
          this.errors = response.data
          this.populateRows()
        })
        .catch(function (error) {
          console.log(error)
        })
      } else {
        console.log('No User Token')
      }
    },
    populateRows() {
      for (let e in this.errors) {
        this.rows.push({
          id: this.errors[e].id,
          comments: this.errors[e].comments,
          dataset: this.errors[e].dataset,
          layer: this.errors[e].layer_name,
          severity: this.getSeverityOrStatus(this.errors[e].severity, true),
          status: this.getSeverityOrStatus(this.errors[e].status, false),
          x: this.errors[e].x,
          y: this.errors[e].y
        })
      }
    },
    // TODO - this seems like a really weird way to implement this -- why not just use two different functions?
    getSeverityOrStatus(value, bool) {
      // If bool is true, return a severity string.
      // If bool is false, return a status string.
      let retVal = ''
      switch (value) {
        case '0':
          retVal = bool ? 'Low' : 'Active'
          break
        case '1':
          retVal = bool ? 'Medium' : 'Pending'
          break
        case '2':
          retVal = bool ? 'High' : 'Resolved'
          break
        case '3':
          retVal = bool ? '' : 'Archived'
          break
        default:
          break
      }
      return retVal
    },
    zoomControlLayers(layers) {
      var zoomAr = []

      for (let key in layers) {
        if (layers[key].zoomControl) {
          var zoomControlLayer = {
            layer: layers[key].layer,
            checkBoxName: key + 'CB'
          }
          zoomAr.push(zoomControlLayer)
        }
      }
      return zoomAr
    }
  },
  mounted() {
    this.getErrorsByProjectId()
  }
}
</script>
